import React from 'react'
import { ConnectionStatusCircle } from './ConnectionStatus.styled'
import { PlatformIconsByStatus, Tooltip } from '@clickcease/cc-client-components-lib'
import { Platforms } from 'src/enums/platforms'
import { getTooltipByStatus } from './ConnectionSatus.utils'

export const PRODUCT_PLATFORMS = {
  paidMarketing: [{ name: 'google' }, { name: 'meta' }, { name: 'microsoft' }],
}

export const PlatformStatus = ({
  product,
  status,
  onOpenModal,
  disabled,
}: {
  product: Platforms
  status: 'enabled' | 'connected' | undefined
  onOpenModal: () => void
  disabled?: boolean
}) => {
  const onClick = () => {
    if (status !== 'enabled') {
      onOpenModal()
    }
  }

  return (
    <Tooltip key={product} tooltiptContent={getTooltipByStatus(status)}>
      <ConnectionStatusCircle
        disabled={disabled}
        status={status}
        onClick={!disabled ? onClick : undefined}
      >
        <PlatformIconsByStatus serviceName={product} isDisabled={!status} />
      </ConnectionStatusCircle>
    </Tooltip>
  )
}
